export default __webpack_public_path__ + "static/media/logo2.95bfb153.png";